import { useState, useEffect } from "react";
import type { UserDataProps } from "src/types";
import { dealerStorage, getIdsFromPath } from "src/utils";

export const usePersistedAppStore = () => {
  const [userData, setUserData] = useState<UserDataProps>({});

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      dealerStorage.setItem("app-state", JSON.stringify(userData));
    }
  }, [userData]);

  useEffect(() => {
    let initState: UserDataProps = {};
    const storedState = dealerStorage.getItem("app-state");
    if (storedState) {
      initState = JSON.parse(storedState) as UserDataProps;
    }

    const { application_id, borrower_id, dealer_id } = getIdsFromPath();

    if (application_id && application_id.length > 0) {
      initState.application_id = application_id;
    }

    if (borrower_id && borrower_id.length > 0) {
      initState.borrower_id = borrower_id;
    }

    if (dealer_id && dealer_id.length > 0) {
      initState.dealer_id = dealer_id;
    }

    if (Object.keys(initState).length > 0) {
      setUserData(initState);
    }
  }, []);

  return { userData, setUserData };
};
